/*
  GetProof.jsx
  ----------------
  Interface pour choisir une preuve à afficher qui redirige vers DisplayProofPage.jsx.
*/

import { useEffect, useState } from 'react';
import { Box, Text, Button, Stack, Loader, Center, Select } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../tools/Context';
import { get } from '../tools/Request';

export default function GetProof() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [linkAvailable, setLinkAvailable] = useState([]);
  const { refreshPage } = useUser();
  const user = useUser();
  const [linkedIds, setLinkedIds] = useState('');

  const handleSubmitFields = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(`/proof?uid=${linkedIds}`);
    }, 500);
  };
  useEffect(() => {
    const fetchContracts = async () => {
      refreshPage(false);
      try {
        const link = await get('link', undefined, localStorage.getItem('userToken'));
        console.log(link);
        setLinkAvailable(link);
      } catch (error) {
        console.error('Error fetching contract data:', error);
        setLinkAvailable([]);
      }
    };
    fetchContracts();
  }, [user, refreshPage]);
  return (
    <Center>
      <Box
        mt="5%"
        backgroundColor="white"
        maw={800}
        style={{
          flex: 1,
          border: '1px solid #ddd',
          borderRadius: '8px',
          padding: '1rem',
          textAlign: 'center',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
        <Text style={{ fontSize: '1.25rem', fontWeight: 500, marginBottom: '1rem' }}>Récupérer une preuve</Text>
        <Stack>
          <Select
            placeholder="Identifiant de la preuve"
            data={linkAvailable.map((link) => ({ value: link.id, label: link.id }))}
            value={linkedIds}
            onChange={setLinkedIds}
            clearable
            searchable
          />
          <Button color="teal" onClick={handleSubmitFields} disabled={loading}>
            {loading ? <Loader size="xs" /> : 'Voir la preuve'}
          </Button>
        </Stack>
      </Box>
    </Center>
  );
}
